import { render, staticRenderFns } from "./dropdown-item.vue?vue&type=template&id=40970bbe&"
import script from "./dropdown-item.vue?vue&type=script&lang=js&"
export * from "./dropdown-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports